// removed by extract-text-webpack-plugin
module.exports = {"select-color":"_FviM"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/customtheme/style.css
// module id = s8o+
// module chunks = 4